import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-increments-sanction-form',
  templateUrl: './increments-sanction-form.component.html',
  styleUrls: ['./increments-sanction-form.component.css']
})
export class IncrementsSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/increments-sanction/increments-sanction-form/increments-sanction-form.component.ts